import { EventBroker } from '../common/EventBroker.js'
import { LogService } from '../common/LogService.js'
import { ProgressbarService } from './ProgressbarService.js'
import { NextButtonService } from './NextButtonService.js'
import { RuntimeContext } from './RuntimeContext.js'
import { RuntimeFactory } from './RuntimeFactory.js'
import * as $ from 'jquery';

class RuntimeMain {
    logService;
    eventBroker;
    progressbarService;
    nextButtonService;
    selector;
    context;
    topNode;
    factory;

    constructor(selector, componentLibrary) {
        this.selector = selector;
        this.logService = new LogService();
        this.eventBroker = new EventBroker(this.logService);
        this.progressbarService = new ProgressbarService('#progressbar-container', this.eventBroker);
        this.nextButtonService = new NextButtonService('#next-button-container', this.eventBroker);
        this.context = new RuntimeContext(this.eventBroker);
        this.factory = new RuntimeFactory(componentLibrary, this.eventBroker, this.context, this.progressbarService);
    }

    run(data, params) {
        $(this.selector).empty();
        $(this.selector).append("<div id='progressbar-container'></div>");
        let cssClass = "dialog-" + data.metadata.jsonName ?? "unknown"
        $(this.selector).append(`<div id='component-container' class='${cssClass}'></div>`);
        $(this.selector).append($("<div id='next-button-container'></div>"));

        if (!params.selector)
            params.selector = this.selector;

        this.eventBroker.clear();

        this.progressbarService.clear();

        this.progressbarService.bind();

        this.nextButtonService.init(params.nextButtonDelay, params);

        this.context.setParams(params);

        this.topNode = this.factory.getNode(data.topNode, this.factory);

        var texts = this.extractTexts(data.languageDefinition, params.languageCultureName);

        this.topNode.setLanguage(texts);

        var $topNode = this.topNode.getRuntimeView();

        this.progressbarService.initProgressbar(params);

        $(this.selector + " #component-container").append(this.topNode.getRuntimeView());

        this.context.fireValueChangedEvents();

        this.eventBroker.fireValueChanged("bmi", "version", data.metadata.version);

        this.eventBroker.fireValueChanged("bmi", "backendUrl", data.metadata.backendUrl);

        this.eventBroker.fire("readyToShowEvent");

        this.topNode.show();

        return this.topNode.frame.presentFrame();
    }

    extractTexts(languageDefinition, languageCultureName) {
        var texts = {};
        for (var i in languageDefinition) {
            texts[i] = {};
            for (var n in languageDefinition[i]) {
                texts[i][n] = { value: languageDefinition[i][n].values[languageCultureName] };
            }
        }
        return texts;
    }
}

export { RuntimeMain }
